import { Injectable } from '@angular/core';
import { GuidStrValue, PatientTrackResultFilter, TrackPatientResultsFilterFormValue, VisibleToEnum, YesNoBoth } from 'webcommon/shared';


@Injectable({
    providedIn: 'root'
})
export class TrackPatientResultFilterUtilityService {

    public mapToResultStatusFilterDto(
        id: GuidStrValue | null,
        name: string,
        externalId: string | null,
        filterForm: TrackPatientResultsFilterFormValue,
        patientId:  GuidStrValue | null,
        notes: string | null,
    ): PatientTrackResultFilter {

        const form = filterForm.details;
        const common = filterForm.common;
        return {
            StatusUids: form.Status ?? [],
            LaboratoryUids: form.Laboratory ?? [],
            ResultUids: form.Results ?? [],
            PatientUid: patientId ?? null,
            UrgencyUids: form.Urgency ?? [],
            TemplateUids: form.Template ?? [],
            AttachmentTypeUids: form.AttachmentType ?? [],
            OrderDateUid: (form.OrderDate) ? form.OrderDate : null,
            DueDateUid: (form.DueDate) ? form.DueDate : null,
            ResultDateUid: (form.ResultDate) ? form.ResultDate : null,
            ProviderUids: form.Provider ?? [],
            ReferringProviderUids: form.ReferringProvider ?? [],
            ServiceSiteUids: form.ServiceSite ?? [],
            ProcedureUids: form.Procedure ?? [],
            PSC: form.PSC ?? YesNoBoth.Both,
            FutureOrders: form.FutureOrders ?? YesNoBoth.Both,
            MaxItems: form.MaximumItemsReturned ?? 100,
            IncludeStrikeouts: form.IncludeStrikeouts ?? false,
            AccessionNumber: form.AccessionNumber ?? '',
            PatientCity: form.PatientCity ?? '',
            PatientState: form.PatientState ?? '',
            PatientZip: form.PatientZip ?? '',
            PatientMode: true,
            SetAsDefaultFilter: common.makeMyDefault ?? false,
            FilterUid: id,
            ExternalID: externalId ?? '',
            Name: name ?? '',
            VisibleToEveryone: (common?.visibleTo ?? VisibleToEnum.Me) === VisibleToEnum.Everyone,
            Notes: notes ?? '',
            UserDefined: true,
            Inactive: false
        };
    }

    public mapToResultStatusFilterApplyDto(
        filterForm: TrackPatientResultsFilterFormValue,
        patientId: GuidStrValue | null,
    ): PatientTrackResultFilter {

        const form = filterForm.details;
        return {
            StatusUids: form.Status ?? [],
            LaboratoryUids: form.Laboratory ?? [],
            ResultUids: form.Results ?? [],
            PatientUid: patientId ?? null,
            UrgencyUids: form.Urgency ?? [],
            TemplateUids: form.Template ?? [],
            AttachmentTypeUids: form.AttachmentType ?? [],
            OrderDateUid: (form.OrderDate) ? form.OrderDate : null,
            DueDateUid: (form.DueDate) ? form.DueDate : null,
            ResultDateUid: (form.ResultDate) ? form.ResultDate : null,
            ProviderUids: form.Provider ?? [],
            ReferringProviderUids: form.ReferringProvider ?? [],
            ServiceSiteUids: form.ServiceSite ?? [],
            ProcedureUids: form.Procedure ?? [],
            PSC: form.PSC ?? YesNoBoth.Both,
            FutureOrders: form.FutureOrders ?? YesNoBoth.Both,
            MaxItems: form.MaximumItemsReturned ?? 100,
            IncludeStrikeouts: form.IncludeStrikeouts ?? false,
            AccessionNumber: form.AccessionNumber ?? '',
            PatientCity: form.PatientCity ?? '',
            PatientState: form.PatientState ?? '',
            PatientZip: form.PatientZip ?? '',
            PatientMode: true,
            SetAsDefaultFilter: false,
            FilterUid: null,
            ExternalID: '',
            Name: '',
            VisibleToEveryone: false,
            Notes: '',
            UserDefined: true,
            Inactive: false
        };
    }

    public mapDtoToFormValue(dto: PatientTrackResultFilter): TrackPatientResultsFilterFormValue {
        return {
            details: {
                Status: dto.StatusUids || null,
                Laboratory: dto.LaboratoryUids || null,
                Results: dto.ResultUids || null,
                AccessionNumber: dto.AccessionNumber || null,
                Patient: dto.PatientUid ? [dto.PatientUid] : null,
                PatientCity: dto.PatientCity || null,
                PatientState: dto.PatientState || null,
                PatientZip: dto.PatientZip || null,
                Urgency: dto.UrgencyUids || null,
                Template: dto.TemplateUids || null,
                AttachmentType: dto.AttachmentTypeUids || null,
                OrderDate: dto.OrderDateUid ?? null,
                DueDate: dto.DueDateUid ?? null,
                ResultDate: dto.ResultDateUid ?? null,
                Provider: dto.ProviderUids || null,
                ReferringProvider: dto.ReferringProviderUids || null,
                ServiceSite: dto.ServiceSiteUids || null,
                Procedure: dto.ProcedureUids || null,
                PSC: dto.PSC ?? YesNoBoth.Both,
                FutureOrders: dto.FutureOrders ?? YesNoBoth.Both,
                MaximumItemsReturned: dto.MaxItems ?? 100,
                IncludeStrikeouts: dto.IncludeStrikeouts ?? false,
            },
            common: {
                visibleTo: dto.VisibleToEveryone ? VisibleToEnum.Everyone : VisibleToEnum.Me,
                makeMyDefault: !!dto.SetAsDefaultFilter
            }
        };
    }
}
